import { Component, OnInit, HostListener } from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { FormComponentCanDeactivate } from '@tmhcc-ng-lib/framwork/grid';
import { Observable } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'ae-test-form',
  templateUrl: './test-form.component.html',
  styleUrls: ['./test-form.component.scss']
})
export class TestFormComponent implements OnInit, FormComponentCanDeactivate {
  sampleForm: FormGroup;
  submitted = false;

  constructor(
    private formBuilder: FormBuilder,
    private loaderService: LoaderService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.sampleForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      mobile: ['', Validators.required],
      address: ['', Validators.required]
    });
    this.loaderService.hide();
  }

  get f() {
    return this.sampleForm.controls;
  }

  onSubmit() {
    if (this.sampleForm.invalid) {
      return;
    } else {
      this.router.navigate(['../dashboard']);
      this.submitted = true;
    }
  }

  SamplecanDeactivate(): Observable<boolean> | boolean {
    const isValid = Object.keys(this.sampleForm.controls).some(key => {
      return this.sampleForm.get(key).value != '';
    });
    if (isValid && this.submitted == false) {
      if (
        confirm(
          'WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.'
        )
      ) {
        return true;
      } else {
        this.loaderService.hide();
        return false;
      }
    } else {
      return true;
    }
  }
}
